import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiClient } from '../api/client';
import { Chat } from '../types';
import './ChatList.css';

export function ChatList() {
  const [chats, setChats] = useState<Chat[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    loadChats();
  }, []);

  async function loadChats() {
    try {
      setLoading(true);
      const response = await apiClient.getChats();
      setChats(response.chats);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load chats');
    } finally {
      setLoading(false);
    }
  }

  function formatDate(date: Date): string {
    const d = new Date(date);
    const now = new Date();
    const diff = now.getTime() - d.getTime();
    const hours = Math.floor(diff / 1000 / 60 / 60);

    if (hours < 24) {
      return d.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
      });
    }

    return d.toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'short',
    });
  }

  // Фильтруем чаты по поисковому запросу
  const filteredChats = chats.filter((chat) => {
    const query = searchQuery.toLowerCase();
    const chatNameMatch = chat.chatName.toLowerCase().includes(query);
    const lastMessageMatch = chat.lastMessage?.text.toLowerCase().includes(query);
    return chatNameMatch || lastMessageMatch;
  });

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  if (error) {
    return <div className="error">Ошибка: {error}</div>;
  }

  return (
    <div className="chat-list">
      <div className="chat-list-header">
        <h1>Чаты</h1>
        <input
          type="text"
          className="search-input"
          placeholder="Поиск..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      {chats.length === 0 ? (
        <div className="empty-state">Нет чатов</div>
      ) : filteredChats.length === 0 ? (
        <div className="empty-state">Ничего не найдено</div>
      ) : (
        <div className="chats">
          {filteredChats.map((chat) => (
            <div
              key={chat.chatId}
              className="chat-item"
              onClick={() => navigate(`/chat/${chat.chatId}`, { state: { chatName: chat.chatName, avatarUrl: chat.avatarUrl } })}
            >
              <div className="chat-avatar">
                {chat.avatarUrl ? (
                  <img src={chat.avatarUrl} alt={chat.chatName} />
                ) : (
                  chat.chatName.charAt(0).toUpperCase()
                )}
              </div>
              <div className="chat-content">
                <div className="chat-header">
                  <span className="chat-name">{chat.chatName}</span>
                  {chat.lastMessage && (
                    <span className="chat-time">
                      {formatDate(chat.lastMessage.date)}
                    </span>
                  )}
                </div>
                <div className="chat-preview">
                  <span className="chat-last-message">
                    {chat.lastMessage?.text || 'Нет сообщений'}
                  </span>
                  {chat.messageCount > 0 && (
                    <span className="chat-count">{chat.messageCount}</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}